import { useContext } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import cn from "classnames";

import { Button } from "../Button";
import { AuthContext } from "providers/AuthProvider/context/AuthContext";

import "./ReserveDoctorButton.scss";

interface ReserveDoctorButtonProps {
  variant?: "page" | "modal";
  className?: string;
}

export const ReserveDoctorButton = ({
  variant = "page",
  className,
}: ReserveDoctorButtonProps) => {
  const { authorizationStage } = useContext(AuthContext);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  return (
    <div
      className={cn(
        "reserve-doctor-button",
        `reserve-doctor-button--${variant}`,
        className
      )}
    >
      <Button
        className="reserve-doctor-button__btn"
        onClick={() =>
          authorizationStage !== "authorized"
            ? navigate("/login")
            : navigate("/pr-visit-doctor/reserve/for")
        }
      >
        {formatMessage({
          id: "main.reserve-doctor",
          defaultMessage: "_reserve-doctor_",
        })}
      </Button>
    </div>
  );
};
